<input type="radio"
       [attr.aria-label]="ariaLabel()"
       [attr.data-invalid]="invalid() || errorState() || null"
       [checked]="checked()"
       [disabled]="disabled()"
       [name]="name()"
       (blur)="handleBlur()"
       (change)="handleChange($event)" />

<!--  This is styled as the radio icon  -->
<span aria-hidden="true"></span>
